var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "button",
    {
      staticClass: "btn grenaz",
      class: { "btn--loading": _vm.isLoading, "btn--secondary": !_vm.isPrimary }
    },
    [
      _vm._v("\n" + _vm._s(_vm.label) + "\n"),
      _vm.isLoading
        ? _c(
            "svg",
            { staticClass: "spinner", attrs: { viewBox: "0 0 50 50" } },
            [
              _c("circle", {
                staticClass: "path",
                attrs: {
                  cx: "25",
                  cy: "25",
                  r: "20",
                  fill: "none",
                  "stroke-width": "5"
                }
              })
            ]
          )
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4fb1e8e5", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4fb1e8e5","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./src/components/component/buttons/button/button.html
// module id = null
// module chunks = 